export const PSLF_ADMIN_STATUS_FILTERS = [
  {
    key: 'borrower_signed',
    labelKey: 'common.pslf.status.needs_review',
    statuses: ['borrower_signed'],
  },
  {
    key: 'awaiting_submit',
    labelKey: 'common.pslf.status.awaiting_submit',
    statuses: ['employer_signed', 'awaiting_submit', 'submit_pending'],
  },
  {
    key: 'rejected',
    labelKey: 'common.pslf.status.rejected',
    statuses: ['rejected'],
  },
  {
    key: 'submitted',
    labelKey: 'common.pslf.status.submitted',
    statuses: ['submitted', 're_submit_pending', 're_submitted'],
  },
  {
    key: 'errored',
    labelKey: 'common.pslf.status.errored',
    statuses: ['submit_errored', 're_submit_errored'],
  },
  {
    key: 'cancelled',
    labelKey: 'common.pslf.status.cancelled',
    statuses: ['cancelled'],
  },
] as const;

export function statusesForPslfAdminStatusFilter(status: string) {
  const filter = PSLF_ADMIN_STATUS_FILTERS.find((option) => option.key === status);

  return filter ? [...filter.statuses] : [status];
}
